import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-6 text-amber-400">Emin Kuyumculuk</h3>
            <p className="text-gray-300 mb-6 leading-relaxed text-sm">
              30 yıllık tecrübemiz ve güvenilir hizmetimizle, altın alışverişinizde yanınızdayız. Sertifikalı ürünler, güvenli ödeme ve sigortalı kargo ile hizmetinizdeyiz.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-amber-600 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-amber-600 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-amber-600 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-amber-600 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-amber-400">Hızlı Bağlantılar</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link to="/kategori" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  Kategoriler
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/sss" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  Sıkça Sorulan Sorular
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-amber-400">Kategoriler</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/kategori?cat=ceyrek-altin" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  Çeyrek/Yarım/Tam Altın
                </Link>
              </li>
              <li>
                <Link to="/kategori?cat=gram-altin" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  Gram Altın
                </Link>
              </li>
              <li>
                <Link to="/kategori?cat=bilezik" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  Bilezik & Kelepçe
                </Link>
              </li>
              <li>
                <Link to="/kategori?cat=kolye" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  Kolye & Yüzük
                </Link>
              </li>
              <li>
                <Link to="/kategori?cat=setler" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  Setler
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-amber-400">İletişim Bilgileri</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-map-pin-line text-amber-400 text-lg"></i>
                </div>
                <span className="text-gray-300 text-sm leading-relaxed">
                  Kamil Ocak Mah. Divrik Cad. 45/A<br />Keçiören / ANKARA
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-line text-amber-400 text-lg"></i>
                </div>
                <a href="tel:05316036891" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  0531 603 68 91
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-mail-line text-amber-400 text-lg"></i>
                </div>
                <a href="mailto:info@eminkuyumculuk.com.tr" className="text-gray-300 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  info@eminkuyumculuk.com.tr
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-time-line text-amber-400 text-lg"></i>
                </div>
                <span className="text-gray-300 text-sm leading-relaxed">
                  Pazartesi - Cumartesi<br />09:00 - 19:00
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2024 Emin Kuyumculuk. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/on-bilgilendirme-formu" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                Ön Bilgilendirme Formu
              </Link>
              <Link to="/mesafeli-satis-sozlesmesi" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                Mesafeli Satış Sözleşmesi
              </Link>
              <Link to="/cerez-politikasi" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                Çerez Politikası
              </Link>
              <Link to="/kvkk-aydinlatma-metni" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                KVKK Aydınlatma Metni
              </Link>
              <Link to="/kullanim-kosullari" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                Kullanım Koşulları
              </Link>
              <Link to="/uyelik-ve-kullanim-sartlari" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                Üyelik Şartları
              </Link>
              <Link to="/iade-politikasi" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                İade Politikası
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
